import { render, staticRenderFns } from "./bidding.vue?vue&type=template&id=321da524&scoped=true"
import script from "./bidding.vue?vue&type=script&lang=js"
export * from "./bidding.vue?vue&type=script&lang=js"
import style0 from "./bidding.vue?vue&type=style&index=0&id=321da524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321da524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('321da524')) {
      api.createRecord('321da524', component.options)
    } else {
      api.reload('321da524', component.options)
    }
    module.hot.accept("./bidding.vue?vue&type=template&id=321da524&scoped=true", function () {
      api.rerender('321da524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/bidding.vue"
export default component.exports